'use strict';

import preact from 'preact';
import React from 'react';

let template = require('./clock.html.rt');

class Clock extends preact.Component {
    constructor() {
        super();
        // set initial time:
        this.state.time = Date.now();
    }

    componentDidMount() {
        // update time every second
        this.timer = setInterval(() => {
            this.setState({time: Date.now()});
        }, 1000);
    }

    componentWillUnmount() {
        // stop when not renderable
        clearInterval(this.timer);
    }

    render(props, state) {
        this.time = new Date(state.time).toLocaleTimeString();
        return template.call(this);
    }
}

let app = angular.module('app');

let clockDirective = function (reactDirective) {
    return reactDirective(Clock);
};
clockDirective.$inject = ['reactDirective'];
app.directive('clock', clockDirective);

export default clockDirective;



// WEBPACK FOOTER //
// .-dna/app/components/clock/clock.js